"use strict";

var _StaticMFEShadowedCom;
import { c as _c } from "react/compiler-runtime";
import { TENANT_NAME } from '@autoguru/global-configs';
import { StaticMFEShadowedComponent } from '@autoguru/static-mfe/static-mfe-shadowed-component';
import { useSelectedGlobalSupplier } from '../GlobalSupplierProvider';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const SupplierRequiredBoundary = t0 => {
  const $ = _c(4);
  const {
    children,
    noSelect
  } = t0;
  const {
    id
  } = useSelectedGlobalSupplier();
  let t1;
  if ($[0] !== children || $[1] !== id || $[2] !== noSelect) {
    t1 = TENANT_NAME !== "nz" || id ? /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }) : noSelect ? null : _StaticMFEShadowedCom || (_StaticMFEShadowedCom = /*#__PURE__*/_jsx(StaticMFEShadowedComponent, {
      width: "full",
      mfeAppName: "sp-supplier-select-home"
    }));
    $[0] = children;
    $[1] = id;
    $[2] = noSelect;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};